import store from '../store/index.js'

export function msg(Message, Timeout = null) {
    store.dispatch('snackbar/openMsg', {
        "msg": Message,
        "timeout": Timeout
    })
}

export function openLoding() {
    store.dispatch('overlay/openOverlay')
}

export function closeLoding() {
    store.dispatch('overlay/closeOverlay')
}